export default "__VITE_ASSET__69ecff1d__"